import Vue from 'vue';
import VueToast from 'vue-toast-notification';
import axios from '@/api/axios';
import i18n from '@/api/i18n/i18n';

Vue.use(VueToast);

function openToast(message, type) {
  Vue.$toast.open({
    message,
    type,
  });
}

function getSettings(link) {
  return axios.post(link).then((response) => {
    if (response.data.success) { return response; }

    openToast(response.data.message, 'error');
    response.data = null;

    return response;
  });
}

export function getCategoryList() {
  return getSettings('/category/categoryList');
}

export function renameGroup(id, name) {
  return axios.post(`/category/renameGroup/?id=${id}`, { name }).then((response) => {
    if (response.data.success) {
      openToast(i18n.t('toast.categoryNameSuccessfullyUpdated'), 'success');
      return 'success';
    }
    openToast(response.data.message, 'error');
    return 'error';
  });
}

export function renameItem(id, name) {
  return axios.post(`/category/renameItem/?id=${id}`, { name }).then((response) => {
    if (response.data.success) {
      openToast(i18n.t('toast.changesSuccessfullySaved'), 'success');
      return 'success';
    }
    openToast(response.data.message, 'error');
    return 'error';
  });
}

export function deleteGroup(id, type) {
  return axios.post(`/category/deleteGroup/?id=${id}&type=${type}`).then((response) => {
    if (response.data.success) {
      openToast(i18n.t('toast.groupSuccessfullyDeleted'), 'success');
      return 'success';
    }
    openToast(response.data.message, 'error');
    return 'error';
  });
}

export function deleteItem(id) {
  return axios.post(`/category/deleteItem/?id=${id}`).then((response) => {
    if (response.data.success) {
      openToast(i18n.t('toast.itemSuccessfullyDeleted'), 'success');
      return 'success';
    }
    openToast(response.data.message, 'error');
    return 'error';
  });
}

export function changeGroup(id, groupId) {
  return axios.post(`/category/changeGroup/?id=${id}&groupId=${groupId}`).then((response) => {
    if (response.data.success) {
      openToast(i18n.t('toast.itemSuccessfullyMoved'), 'success');
      return 'success';
    }
    openToast(response.data.message, 'error');
    return 'error';
  });
}

export function addItem(name, id, type) {
  return axios.post(`/category/addItem/?name=${name}&groupId=${id}`).then((response) => {
    if (response.data.success) {
      if (type === 1) { openToast(i18n.t('toast.programSuccessfullyAdded'), 'success'); }
      if (type === 2) { openToast(i18n.t('toast.websiteSuccessfullyAdded'), 'success'); }
      return 'success';
    }
    openToast(response.data.message, 'error');
    return 'error';
  });
}

export function addGroup(name, type, color) {
  return axios.post(`/category/addGroup/?name=${name}&type=${type}&color=${color}`).then((response) => {
    if (response.data.success) {
      openToast(i18n.t('toast.categorySuccessfullyAdded'), 'success');
      return 'success';
    }
    openToast(response.data.message, 'error');
    return 'error';
  });
}

export function changeColor(id, color) {
  return axios.post(`/category/changeColor/?id=${id}&color=${color}`).then((response) => {
    if (response.data.success) {
      openToast(i18n.t('toast.categoryColorSuccessfullyUpdated'), 'success');
      return 'success';
    }
    openToast(response.data.message, 'error');
    return 'error';
  });
}
